import {IBaseLookup} from "./Ibase.lookup";

export namespace FlagWeb {

	export const lookupName:string = "FlagWeb";

	export enum IndicationType { all = 1, worklist = 2, patient = 3 }

	export interface FlagWeb {
		flagWebKey:number;
		name:string;
		fieldDisplayCondition:string;
		indicationType:IndicationType;
		active:string;
		tableLevel:number;
		fieldName:string;
		description:string;
		priority:number;
		webCalculation:string;
		webActionKey:number;
		migratedWorklistFlagKey:number;
		image:string;
		iconSvgKey:number;
		openActionAsTooltip:string;
	}

	export interface FlagWebDS extends IBaseLookup {
		flagWeb:FlagWeb[];
	}
}
